"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.startNewSession = exports.getSessionProperties = void 0;
var logger_1 = require("../logger");
var log = (0, logger_1.getLogger)("session");
var sessionProperties;
function getSessionProperties() {
    if (sessionProperties === undefined) {
        startNewSession("COLD");
    }
    return sessionProperties;
}
exports.getSessionProperties = getSessionProperties;
function startNewSession(appStartupType) {
    var props = {
        sessionId: generateBase64SessionId(),
        appStartupType: appStartupType
    };
    log.debug("Started new Blizzard session:", props);
    sessionProperties = props;
}
exports.startNewSession = startNewSession;
var SESSION_ID_LENGTH_BYTES = 12;
function generateBase64SessionId() {
    return btoa(String.fromCharCode.apply(String, __spreadArray([], __read(self.crypto.getRandomValues(new Uint8Array(SESSION_ID_LENGTH_BYTES))), false)));
}
//# sourceMappingURL=session.js.map